import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "text-4xl font-medium capitalize" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = { class: "text-4xl font-medium capitalize" }
const _hoisted_9 = { class: "text-2xl font-medium" }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "mt-6" }
const _hoisted_14 = { class: "text-4xl font-medium capitalize" }
const _hoisted_15 = { class: "text-2xl font-medium" }
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "block mt-1 font-medium" }
const _hoisted_18 = { class: "block mt-1 font-medium" }
const _hoisted_19 = { class: "block mt-1 font-medium" }
const _hoisted_20 = { class: "mt-6" }
const _hoisted_21 = { class: "text-4xl font-medium capitalize" }
const _hoisted_22 = { class: "text-2xl font-medium" }
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "font-medium" }
const _hoisted_25 = { class: "mt-6 overflow-x-auto" }
const _hoisted_26 = { class: "grid items-center justify-between md:grid-cols-2" }
const _hoisted_27 = { class: "col-span-1" }
const _hoisted_28 = { class: "text-4xl font-medium capitalize" }
const _hoisted_29 = { class: "mt-1 text-2xl font-medium" }
const _hoisted_30 = { class: "flex justify-end col-span-1" }
const _hoisted_31 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_32 = { class: "font-medium" }
const _hoisted_33 = { class: "font-medium" }
const _hoisted_34 = { class: "mt-6 overflow-x-auto" }
const _hoisted_35 = { class: "grid items-center justify-between md:grid-cols-2" }
const _hoisted_36 = { class: "col-span-1" }
const _hoisted_37 = { class: "text-4xl font-medium" }
const _hoisted_38 = { class: "mt-1 text-2xl font-medium" }
const _hoisted_39 = { class: "flex justify-end col-span-1" }
const _hoisted_40 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_41 = { class: "font-medium" }
const _hoisted_42 = { class: "font-medium" }
const _hoisted_43 = { class: "mt-6 overflow-x-auto" }
const _hoisted_44 = { class: "grid items-center justify-between md:grid-cols-2" }
const _hoisted_45 = { class: "col-span-1" }
const _hoisted_46 = { class: "text-4xl font-medium" }
const _hoisted_47 = { class: "mt-1 text-2xl font-medium" }
const _hoisted_48 = { class: "flex justify-end col-span-1" }

import { ref } from "vue";

import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";

import api from "@/api/api";
import { Booking, Club, Event } from "@/types";
import ListRowItem from "@/components/ListRowItem.vue";
import OrdersTable from "@/components/tables/OrdersTable.vue";
import DefaultButton from "@/components/DefaultButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteData',
  async setup(__props) {

let __temp: any, __restore: any

const events = ref([] as Event[]);
const clubs = ref([] as Club[]);
const orders = ref([] as Booking[]);
const reports = ref({
  users: {
    users: {
      signups: 0,
      total: 0,
    },
  },
  subs: {
    subscriptions: 0,
    renewals: 0,
  },
  sales: {},
  organisations: {},
});

async function listEvents() {
  events.value = (
    await api.events.listEvents({
      page: "all",
    })
  ).data.events;
}

async function listOrders() {
  orders.value = (await api.bookings.listRecentOrders()).data.bookings;
}

async function listClubs() {
  clubs.value = (
    await api.clubs.listClubs({
      page: "all",
    })
  ).data.clubs;
}

async function exportDataDump() {
  try {
    const response = await api.reports.exportDataDump();
    console.log(response);

    if (response.error) {
      throw new Error(response.error);
    }

    // We get a URL to download the data dump
    const url = response.data.url;

    // Create a link element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = response.data.name; // Set the desired file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error exporting data dump:", error);
  }
}

/** Sales Data */
async function getReports() {
  const response = await Promise.all([api.reports.getUsersReports(), api.reports.getSubsReports(), api.reports.getSalesReport(), api.reports.getOrgsReport()]);

  reports.value.users = response[0].data;
  reports.value.subs = response[1].data;
  reports.value.sales = response[2].data;
  reports.value.organisations = response[3].data;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listEvents())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listOrders())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listClubs())),
  await __temp,
  __restore()
);

;(
  ([__temp,__restore] = _withAsyncContext(() => getReports())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('website-data'),
        class: "mt-4"
      }, null, 8, ["title"]),
      _createVNode(DefaultButton, {
        type: "primary",
        onClick: exportDataDump
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Export Data Dump ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("users")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createVNode(ListRowItem, {
            title: _ctx.$t('new-users-this-month')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(reports.value.users.users.signups), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('total-users')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(reports.value.users.users.total), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("subscriptions")), 1),
      _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("all-time")), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", null, [
          _createVNode(ListRowItem, {
            title: _ctx.$t('total')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(reports.value.subs.subscriptions), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('renewals')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(reports.value.subs.renewals), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t("sales")), 1),
      _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("all-time")), 1),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", null, [
          _createVNode(ListRowItem, { title: "Stripe" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_17, "£" + _toDisplayString(reports.value.sales.stripe.amount), 1)
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "TwoCheckout" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_18, "£" + _toDisplayString(reports.value.sales.twocheckout.amount), 1)
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, {
            title: _ctx.$t('invoice')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_19, "£" + _toDisplayString(reports.value.sales.invoice.amount), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t("organisations")), 1),
      _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t("all-time")), 1),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("ul", null, [
          _createVNode(ListRowItem, {
            title: _ctx.$t('total')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_24, _toDisplayString(reports.value.organisations.total_organisations), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("courses")), 1),
          _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t("all-time")), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(RouterButton, {
            to: { name: 'Training_Events' },
            type: "primary",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("view-all-courses")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      (events.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("ul", null, [
              _createVNode(ListRowItem, {
                title: _ctx.$t('currently-live')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(events.value.filter(i => i.status === "published").length), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('completed')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(events.value.filter(i => i.status === "completed").length), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h2", _hoisted_37, _toDisplayString(_ctx.$t("brick-clubs")), 1),
          _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.$t("all-time")), 1)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(RouterButton, {
            to: { name: 'Brick_Clubs' },
            type: "primary",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("view-all-clubs")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      (clubs.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("ul", null, [
              _createVNode(ListRowItem, {
                title: _ctx.$t('currently-live')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(clubs.value.filter(i => i.status === "published").length), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('completed')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(clubs.value.filter(i => i.status === "completed").length), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("h2", _hoisted_46, _toDisplayString(_ctx.$t("orders")), 1),
          _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.$t("all-time")), 1)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(RouterButton, {
            to: { name: 'Orders' },
            type: "primary",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("view-all-orders")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(OrdersTable, { orders: orders.value }, null, 8, ["orders"])
    ])
  ], 64))
}
}

})